var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.531 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.969,0a4.968,4.968,0,1,0,4.969,4.968A4.974,4.974,0,0,0,125.969,0Zm0,8.833a3.864,3.864,0,1,1,3.864-3.864A3.869,3.869,0,0,1,125.969,8.833Z",
    transform: "translate(-121)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.08,301H37.92A8.249,8.249,0,0,0,31,304.7v4.068H48V304.7A8.251,8.251,0,0,0,41.08,301Zm5.786,6.661H32.133v-2.626A7.111,7.111,0,0,1,37.92,302.1H41.08a7.111,7.111,0,0,1,5.786,2.931Z",
    transform: "translate(-31 -301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.708efe9d78afe2ecb21434def9936a35.svg";
export { ForwardRef as ReactComponent };